export function QuoteBox(props) {
	return (
		<div onClick={() => props.selectQuote()} key={props.trip_type} className={props.selected ? 'col quote selected': 'col quote'}>
			<h2 className="h2 text-primary m-0">${props.price}</h2>
			<small>+ 16% VAT</small> <br />
			<span className="h5 text-muted m-0">{props.trip_type}</span>
		</div>
	)
}